<template>
  <div id="app">
    <router-view v-if="!loading" />
  </div>
</template>
<script>
import { mapActions } from "vuex";
import authServices from "@/services/auth";

export default {
  name: 'App',
  data() {
    return {
      loading: false
    }
  },
  async beforeMount() {
    const loginInfo = authServices.loginInfo();
    if (loginInfo) {
      this.loading = true;
      await this.setAllOrganizations();
      this.loading = false;
    }
  },
  methods: {
    ...mapActions("organization", ["setAllOrganizations"]),
  }
}
</script>
<style></style>
